<app-selector label="Cross Words Game" [isEmptySelectable]="isEmptySelectable" [data]="crossWordsGameCoreService.crossWordsGameList$| async" displayKey="name"
    [formControl]="ctrl" (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="crossWordsGameCoreService.loading" [hint]="hint">
</app-selector>
